
import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { SortableMissionCard } from './SortableMissionCard';

interface KanbanColumnProps {
    id: string;
    title: string;
    count: number;
    headerStyle: string;
    items: any[];
    activeMenuId: string | null;
    setActiveMenuId: (id: string | null) => void;
    updateMissionStatus: (id: string, status: string) => void;
    deleteMission: (id: string) => void;
    archiveMission: (id: string) => void;
    onCardClick: (mission: any) => void;
}

export const KanbanColumn: React.FC<KanbanColumnProps> = ({
    id,
    title,
    count,
    headerStyle,
    items,
    activeMenuId,
    setActiveMenuId,
    updateMissionStatus,
    deleteMission,
    archiveMission,
    onCardClick
}) => {
    const { setNodeRef } = useDroppable({ id });

    return (
        <div className="flex-1 flex flex-col min-w-[320px]">
            {/* Column Header */}
            <div className={`flex items-center justify-between px-4 py-3 rounded-t-xl border-b border-transparent ${headerStyle} mb-3 shadow-sm`}>
                <span className="font-bold text-sm tracking-wide text-slate-800">{title}</span>
                <span className="bg-white/60 px-2 py-0.5 rounded-full text-xs font-bold text-slate-600 shadow-sm border border-slate-200/50">
                    {count}
                </span>
            </div>

            {/* Column Body - Droppable Area */}
            <div
                ref={setNodeRef}
                className="flex-1 rounded-2xl bg-slate-100/50 p-3 space-y-3 overflow-y-auto"
            >
                <SortableContext
                    items={items.map(i => i.id)}
                    strategy={verticalListSortingStrategy}
                >
                    {items.map(mission => (
                        <SortableMissionCard
                            key={mission.id}
                            mission={mission}
                            activeMenuId={activeMenuId}
                            setActiveMenuId={setActiveMenuId}
                            updateMissionStatus={updateMissionStatus}
                            deleteMission={deleteMission}
                            archiveMission={archiveMission}
                            columnId={id}
                            onClick={() => onCardClick(mission)}
                        />
                    ))}
                </SortableContext>
            </div>
        </div>
    );
};
